<template>
    <div>
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button v-if="!isEdit" type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveWasted()" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
        </p>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.casare') }}</p>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.locatie') }}</label>
                  <select class="form-control" v-model="selectedLocationId" :disabled="isEdit">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="gestiune">{{ $t('gestiune.gestiune') }}*</label>
                  <select v-model="bonCasare.gestiune" class="form-control" :disabled="isEdit">
                    <option disabled :value="null">Selectează gestiunea</option>
                    <option
                      v-for="gestiune in filteredGestiuni"
                      :key="gestiune.id"
                      :value="gestiune.id"
                    >
                      {{ gestiune.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="serie">{{ $t('invoice.series') }}*</label>
                   <select v-model="bonCasare.serie" class="form-control" @change="handleSerieChange" :disabled="isEdit">
                    <!-- Placeholder -->
                    <option disabled value="">Selectează seria</option>

                    <option
                      v-for="serie in seriesOptionsWithAdd"
                      :key="serie.id"
                      :value="serie.id"
                    >
                      {{ serie.id === 'add' ? serie.name : `${serie.name} - ${serie.currentNumber}` }}
                    </option>

                    <option
                      v-if="bonCasare.serie && !seriesOptionsWithAdd.some(s => s.id === bonCasare.serie)"
                      :value="bonCasare.serie"
                    >
                      {{ bonCasare.serie }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="lot">{{ $t('gestiune.lot') }}</label>
                  <el-input v-model="bonCasare.lot" placeholder="Introdu lotul" :disabled="isEdit" />
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.data')}}*</label>
                  <input type="datetime-local" name="date" v-model="bonCasare.date" :max="today" :disabled="!selectedLocationId" class="form-control">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="col-md-12">
            <p>{{$t('gestiune.addProductInCasare')}}</p>
            <hr class="sm">
          </div>

          <div>
            <div class="product-search" style="position: relative; width: 20%; margin-bottom: 25px;">
              <v-select
                v-if="!isEdit"
                :disabled="!selectedLocationId"
                v-model="searchProdName"
                :options="searchResults"
                label="label"
                placeholder="Caută un produs..."
                :filterable="true"
                @search="fetchProducts"
                @input="onProductSelect"
                style="width: 100%; position: relative;"
              ></v-select>
              <div v-if="loading" class="v-select-loader"></div>
            </div>

            <table class="tree-table" v-if="selectedProducts.length > 0">
              <thead>
                <tr>
                  <th style="width: 25%;">Produs</th>
                  <th style="width: 55%;">Structură Stoc (Grupuri → Intrări)</th>
                  <th v-if="!isEdit" style="width: 20%;">Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                <tr style="height: 3px;"><td colspan="3"></td></tr>

                <!-- Produse selectate -->
                <template v-for="(item, index) in selectedProducts">
                  <!-- Rând pentru produs (nume + UM) -->
                  <tr :key="'product-' + item.product._id" class="product-row">
                    <td colspan="2" class="product-cell">
                      <div style="font-weight: 600; font-size: 16px;">
                        {{ item.product.name }}
                        <span class="badge-um">{{ item.product.um }}</span>
                      </div>
                    </td>
                    <td class="actions-cell" v-if="!isEdit">
                      <button
                        class="btn btn-danger btn-sm action-button"
                        @click="removeProduct(index)"
                        title="Șterge produs"
                      >
                        Șterge Produs
                      </button>
                    </td>
                  </tr>

                  <!-- Rând pentru structură arbore -->
                  <tr :key="'tree-' + item.product._id">
                    <td colspan="3" class="tree-content-cell">
                      <template v-for="(group, groupIndex) in item.stockGroups">
                        <div class="group-branch" :key="'group-' + groupIndex">
                          <!-- Header grup -->
                          <div class="group-header">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                              <div>
                                <strong style="color: #28a745;">Lot:</strong> {{ group.lot || 'N/A' }}
                              </div>
                              <div v-if="group.price != null">
                                <strong style="color: #0066cc;">Preț:</strong> {{ group.price }} {{ group.currency }}
                              </div>
                            </div>
                          </div>

                          <!-- Intrări -->
                          <div
                            v-for="(entry, entryIndex) in group.entries"
                            :key="'entry-' + entry.id"
                            class="entry-branch"
                          >
                            <div class="entry-row">
                              <div class="entry-field" style="flex: 2;">
                                <label>Document</label>
                                <div class="value">{{ entry.document_type || entry.id }}</div>
                              </div>

                              <div class="entry-field" style="flex: 0.8;">
                                <label>UM</label>
                                <div class="value">{{ entry.um || item.product.um }}</div>
                              </div>

                              <div class="entry-field" style="flex: 1;">
                                <label>Disponibil</label>
                                <div class="value">{{ entry.available_quantity }}</div>
                              </div>

                              <div class="entry-field" style="flex: 1.5;">
                                <label>Cant. Casare</label>
                                <input
                                  type="number"
                                  min="0"
                                  :disabled="isEdit"
                                  :max="entry.available_quantity"
                                  class="form-control form-control-sm"
                                  v-model.number="entry.cantitate_casare"
                                  placeholder="Introduce"
                                  @input="validateCasare(entry)"
                                />
                              </div>
                            </div>
                          </div>

                          <!-- Total grup -->
                          <div class="group-total" v-if="group.total_quantity && group.total_value">
                            <div>Total cantitate: <strong>{{ group.total_quantity }}</strong></div>
                            <div>
                              Total valoare:
                              <strong>{{ new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(group.total_value) }} {{ group.currency }}</strong>
                            </div>
                          </div>
                        </div>
                      </template>
                    </td>
                  </tr>
                </template>

              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ManagementSeriesAdd
        :locations="locations"
        :grouped-locations="groupedLocations"
        :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
        @getSeries="getSeries"
      />
    </div>
</template>

<script>
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
  import swal from 'sweetalert2'

  function getLocalDateTimeString () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  export default {
    components: {
      PSwitch,
      ManagementSeriesAdd
    },
    data () {
      return {
        searchProdName: null,
        searchResults: [],
        selectedLocationId: '',
        selectedLocation: null,
        locations: [],
        gestiuneOptions: [],
        selectedProducts: [],
        seriesOptions: [],
        currencyOptions: [
          { code: 'RON', name: 'Leu Românesc (RON)' },
          { code: 'EUR', name: 'Euro (EUR)' },
          { code: 'USD', name: 'Dolar American (USD)' }
        ],
        bonCasare: {
          date: getLocalDateTimeString(),
          gestiune: null,
          serie: null,
          currency: 'RON',
          manager: '',
          receiver: '',
          internalNote: '',
          commandProject: '',
          consumptionType: '',
          lot: ''
        },
        debounceTimer: null,
        loading: false,
        isEdit: !!this.route.params.series && !!this.route.params.number,
        editIndex: null,
        tableData: [],
        stockGroups: [],
        newItem: {
          unitMeasure: '',
          quantity: 0,
          stocFaptic: 0
        }
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.seriesOptions,
          { id: 'add', name: '➕ Adaugă serie' }
        ]
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'
          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocationId) return []
        const result = this.gestiuneOptions.filter(
          (g) => g.externalLocationId === this.selectedLocationId
        )
        return result
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      this.fetchGestiuni()
      this.fetchLocation()
    },
    watch: {
      selectedLocationId (id) {
        if (!this.isEdit) {
          this.bonCasare.gestiune = null
          this.bonCasare.serie = null
          this.series = null
          this.documentNumber = null
          this.selectedLocation = null
        }

        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code)
            }
            break
          }
        }
      },
      locations (newLocations) {
        if (newLocations && newLocations.length) {
          const s = this.route && this.route.params && this.route.params.series
          const inv = this.route && this.route.params && this.route.params.number
          if (s && inv) {
            this.fetchBonCasare(s, inv)
          }
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveWasted() }
        })
      },
      validateCasare (entry) {
        if (entry.cantitate_casare > entry.available_quantity) {
          entry.cantitate_casare = entry.available_quantity
        }
        if (entry.cantitate_casare < 0) {
          entry.cantitate_casare = null
        }
      },
      getEmptyItem () {
        return {
          editIndex: null,
          productObject: null,
          um: 'buc',
          cantitate: null
        }
      },
      handleSerieChange (event) {
        const val = event.target.value
        if (val === 'add') {
          this.openSeriesModal()
          this.bonCasare.serie = null
        }
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      async fetchBonCasare (seriesParam, documentNumberParam) {
        try {
          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument?tip=bon_casare&series=${seriesParam}&number=${documentNumberParam}&externalCompanyId=${this.companyID}`
          )

          if (!response.ok) throw new Error('Failed to fetch bon de casare')

          const data = await response.json()

          if (!data || !Array.isArray(data.documents) || !data.documents.length) {
            throw new Error('Bon de casare inexistent')
          }

          const bon = data.documents[0]

          const extra = bon.extraFields || []
          const getField = (key) => {
            const field = extra.find(f => f.key === key)
            return field ? field.value : ''
          }

          const matchedGestiune = this.gestiuneOptions.find(g => g.name === bon.gestiune_from)
          const gestiuneId = matchedGestiune ? matchedGestiune.id : bon.gestiune_from

          this.bonCasare = {
            ...this.bonCasare,
            gestiune: gestiuneId,
            serie: bon.series,
            lot: bon.lot || '',
            date: bon.date ? new Date(bon.date).toISOString().slice(0, 16) : null,
            documentNumber: bon.documentNumber,
            manager: getField('manager'),
            receiver: getField('receiver'),
            internalNote: getField('internalNote'),
            commandProject: getField('commandProject'),
            consumptionType: getField('consumptionType')
          }

          this.selectedProducts = (bon.items || []).map(item => ({
            product: {
              _id: item.posId,
              name: item.name,
              um: item.um
            },
            cantitate_casare: item.quantity,
            stockGroups: item.stockSelections.map(sel => ({
              entries: [{
                id: sel.source_move_id,
                cantitate_casare: sel.quantity
              }]
            }))
          }))

          if (bon.externalLocationId && this.locations && this.locations.length) {
            let foundLocation = null
            for (const group of this.groupedLocations) {
              foundLocation = group.locations.find(loc =>
                (bon.externalLocationId && loc.true_id === bon.externalLocationId) ||
                (bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber)
              )
              if (foundLocation) break
            }
            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }
        } catch (error) {
          console.error('Error fetching bon de casare:', error)
        }
      },
      async fetchProducts (searchTerm) {
        clearTimeout(this.debounceTimer)

        // așteptăm 400ms după ultima tastă
        this.debounceTimer = setTimeout(async () => {
          this.searchResults = []

          if (!this.selectedLocation || !this.companyID || !this.bonCasare.gestiune || !searchTerm || searchTerm.length < 2) {
            return
          }

          let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}`
          url += `&gestiune=${this.bonCasare.gestiune}`
          url += `&externalLocationId=${this.selectedLocation.true_id}`
          url += `&name=${encodeURIComponent(searchTerm)}`

          this.loading = true
          try {
            const response = await fetch(url)
            const data = await response.json()

            if (Array.isArray(data.products)) {
              this.searchResults = data.products.map(item => ({
                label: item.name,
                posId: item._id,
                value: item
              }))
              console.log(this.searchResults)
            } else {
              this.searchResults = []
              console.error('Invalid data format:', data)
            }
          } catch (error) {
            console.error('Error fetching stock:', error)
          } finally {
            this.loading = false
          }
        }, 400)
      },
      async onProductSelect (selected) {
        if (!selected) return

        const product = selected.value

        // Verificăm dacă produsul este deja selectat
        const exists = this.selectedProducts.some(item => item.product._id === product._id)
        if (exists) {
          swal({
            type: 'warning',
            title: 'Produs deja selectat',
            text: 'Acest produs a fost deja adăugat.'
          })
          this.searchProdName = null
          return
        }

        // Afișăm loading
        swal({
          title: 'Se încarcă stocul...',
          text: 'Așteaptă te rog.',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          type: 'info'
        })

        try {
          const params = new URLSearchParams({
            gestiune: this.bonCasare.gestiune,
            product_id: product._id,
            externalCompanyId: this.companyID,
            externalLocationId: this.selectedLocation.true_id
          }).toString()

          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/stock_details?${params}`
          const response = await fetch(url)
          const data = await response.json()

          // Închidem loading-ul
          swal.close()

          // Verificăm dacă există grupuri
          if (!data.groups || !Array.isArray(data.groups) || !data.groups.length) {
            swal({
              type: 'warning',
              title: 'Produs indisponibil',
              text: 'Acest produs nu are stoc disponibil în gestiune și nu poate fi casat.'
            })
            this.searchProdName = null
            return
          }

          // Dacă există grupuri, adăugăm produsul
          const newItem = {
            product,
            cantitate_casare: null,
            stockGroups: data.groups.map(g => ({
              ...g,
              entries: g.entries.map(e => ({ ...e, cantitate_casare: null }))
            }))
          }

          this.selectedProducts.push(newItem)
          this.searchProdName = null
        } catch (error) {
          swal.close()
          console.error('Eroare la preluarea stocurilor detaliate:', error)
          swal({
            type: 'error',
            title: 'Eroare',
            text: 'Nu s-a putut verifica stocul produsului.'
          })
        }
      },
      async saveWasted () {
        // Verificăm dacă există produse selectate
        if (!this.selectedProducts || this.selectedProducts.length === 0) {
          swal({
            title: 'Eroare',
            text: 'Trebuie să adaugi cel puțin un produs pentru casare.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        // Construim lista de iteme pentru request
        const items = []

        this.selectedProducts.forEach(productItem => {
          if (productItem.stockGroups && Array.isArray(productItem.stockGroups)) {
            productItem.stockGroups.forEach(group => {
              if (group.entries && Array.isArray(group.entries)) {
                // Construim selecțiile pentru fiecare entry
                const stockSelections = group.entries
                  .filter(e => e.cantitate_casare && e.cantitate_casare > 0)
                  .map(e => ({
                    source_move_id: e.id, // ID-ul din stock entry
                    quantity: e.cantitate_casare
                  }))

                if (stockSelections.length) {
                  // calculăm total cantitate casare din acel grup
                  const totalCasare = stockSelections.reduce((acc, s) => acc + s.quantity, 0)

                  items.push({
                    posId: productItem.product._id,
                    name: productItem.product.name,
                    group_id: group.group_id || group.id || null,
                    lot: group.lot || null,
                    quantity: totalCasare,
                    um: productItem.product.um || group.um,
                    price: group.price,
                    stockSelections
                  })
                }
              }
            })
          }
        })

        // Validăm dacă s-a completat vreo cantitate
        if (!items.length) {
          swal({
            title: 'Eroare',
            text: 'Nu ai completat nicio cantitate pentru casare.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const selectedSerie = this.seriesOptions.find(
          serie => serie.id === this.bonCasare.serie || serie.name === this.bonCasare.serie
        )
        const serieName = selectedSerie ? selectedSerie.name : this.bonCasare.serie || null

        // Construim obiectul principal pentru trimitere
        const bonCasareData = {
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          tip: 'bon_casare',
          gestiune_from: this.bonCasare.gestiune,
          date: this.bonCasare.date,
          series: serieName,
          items
        }

        // Afișăm mesaj de "loading"
        swal({
          title: 'Salvare în curs...',
          text: 'Se salvează Bonul de Casare. Așteaptă te rog.',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          type: 'info'
        })

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/bon`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(bonCasareData)
          })

          const data = await response.json()
          swal.close()

          if (response.ok) {
            console.log('Bon casare salvat cu succes!', data)
            swal({
              title: 'Succes',
              text: 'Bonul de casare a fost salvat cu succes!',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
          } else {
            console.error('Eroare la salvarea bonului casare', data)
            swal({
              title: 'Eroare',
              text: data.details || data.error || 'A apărut o eroare la salvarea bonului de casare.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal.close()
          console.error('Eroare la trimiterea cererii', error)
          swal({
            title: 'Eroare',
            text: 'Nu s-a putut trimite cererea către server.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      confirmCasare (entry) {
        console.log(`Casare pentru ${entry.id || entry.product_id}: ${entry.cantitate_casare} buc.`)
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')

          const data = await response.json()
          console.log('Date primite de la server:', data.gestiuni)
          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuneOptions = data.gestiuni.map(gest => ({
              id: gest._id,
              name: `${gest.name} (${gest.cod_gestiune})`,
              externalLocationId: gest.externalLocationId || ''
            }))
          } else {
            swal({
              title: 'Error!',
              text: 'Nu s-a primit un array valid de la server.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Request failed: ${error.message}`,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      async getSeries (vatNumber) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: 'bon_casare'
            })
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()
          console.log('Serii primite:', data.series)

          if (Array.isArray(data.series)) {
            this.seriesOptions = data.series.map(serie => ({
              id: serie._id,
              name: serie.series,
              currentNumber: serie.currentNumber
            }))
          } else {
            console.error('Format invalid pentru series:', data)
          }
        } catch (error) {
          console.error('Error fetching series:', error)
        }
      },
      removeProduct (index) {
        this.selectedProducts.splice(index, 1)
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style scoped>
.tree-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.tree-table td {
  padding: 15px;
  vertical-align: top;
}

.product-cell {
  background: #e8f4f8;
  border-left: 4px solid #0066cc;
  font-weight: bold;
  position: relative;
}

.tree-content-cell {
  background: #f8f9fa;
  position: relative;
}

.group-branch {
  position: relative;
  margin-left: 20px;
  padding-left: 25px;
  margin-bottom: 20px;
  border-left: 3px solid #0066cc;
}

.group-branch::before {
  content: '';
  position: absolute;
  left: -3px;
  top: 30px;
  width: 20px;
  height: 3px;
  background: #0066cc;
}

.group-header {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 15px;
  border-left: 4px solid #28a745;
}

.entry-branch {
  position: relative;
  margin-left: 30px;
  padding-left: 20px;
  margin-bottom: 10px;
  border-left: 2px solid #28a745;
}

.entry-branch::before {
  content: '';
  position: absolute;
  left: -2px;
  top: 15px;
  width: 15px;
  height: 2px;
  background: #28a745;
}

.entry-row {
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  gap: 15px;
}

.entry-field {
  flex: 1;
}

.entry-field label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
  font-weight: 700;
  text-transform: uppercase;
}

.entry-field .value {
  font-size: 1.3rem;
  color: #000;
  font-weight: 600;
}

.group-total {
  background: #e7f5e9;
  padding: 10px 15px;
  border-radius: 6px;
  margin-top: 10px;
  text-align: right;
  font-weight: bold;
  border: 1px solid #28a745;
}

.btn-primary {
  background: #684BF0;
}

.btn-primary:hover {
  background: #563dce;
}

.actions-cell {
  background: #fff3cd;
  text-align: center;
}

.action-button {
  display: block;
  width: 100%;
  padding: 14px;
  margin-bottom: 8px;
}

.btn-confirm {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  font-size: 0.9rem;
}

.btn-confirm:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
  background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
}

.btn-confirm:disabled {
  background: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-delete {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 12px 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  font-size: 1rem;
}

.btn-delete:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
}

.btn-delete:active {
  transform: translateY(0);
}

.badge-um {
  display: inline-block;
  background: #6c757d;
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 5px;
}
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.v-select .dropdown-toggle {
    height: 46px;
}
.btn-primary {
  padding: 5px 50px;
}
th {
  font-weight: 500;
}
.el-select,
.el-input {
  display: block;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.v-select-wrapper {
  position: relative;
}
.dropdown.v-select.searchable {
  background: transparent !important;
}
.v-select-loader {
  position: absolute;
  right: 40px;
  top: 68%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.arrow-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 2px solid #674BD2;
  border-radius: 6px;
  color: #674BD2;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
}

.arrow-box:hover {
  background-color: #674BD2;
  color: #fff;
}

.custom-dropdown-menu {
  min-width: 140px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Wasted/ManagementWastedForm.vue